<template>
<div
  class="leroy"
  :class="{
    'eyes-half': eyesState === 'half',
    'eyes-closed': eyesState === 'closed'
  }"
>
  <div class="leroy__eyebrows"></div>
  <div class="leroy__eyes">
    <div class="leroy__eyes-open"></div>
    <div class="leroy__eyes-half"></div>
    <div class="leroy__eyes-closed"></div>
  </div>
  <div class="leroy__mouth"></div>
  <div class="leroy__tear" v-if="tear"></div>
</div>
</template>

<script>
export default {
  name: 'leroy',
  props: {
    tear: Boolean
  },
  data () {
    return {
      eyesState: '',
      eyesTimeCounter: 0,
      eyesInterval: null,
      eyesIntervalPeriod: 100
    }
  },
  mounted () {
    clearInterval(this.eyesInterval)
    this.eyesInterval = setInterval(() => {
      if (this.eyesTimeCounter === (this.eyesIntervalPeriod * 50)) {
        this.eyesState = 'half'
        this.eyesTimeCounter += this.eyesIntervalPeriod
      } else if (this.eyesTimeCounter === (this.eyesIntervalPeriod * 51)) {
        this.eyesState = 'closed'
        this.eyesTimeCounter = 0
      } else {
        this.eyesState = ''
        this.eyesTimeCounter += this.eyesIntervalPeriod
      }
    }, this.eyesIntervalPeriod)
  },
  beforeDestroy () {
    clearInterval(this.eyesInterval)
  }
}
</script>

<style lang="scss">
@keyframes eyebrows {
  0% {
    transform: translate3d(0,0%,0);
  }
  10% {
    transform: translate3d(0,0%,0);
  }
  40% {
    transform: translate3d(0,58%,0);
  }
  60% {
    transform: translate3d(0,58%,0);
  }
  90% {
    transform: translate3d(0,0%,0);
  }
  100% {
    transform: translate3d(0,0%,0);
  }
}
@keyframes tear {
  0% {
    opacity: 0;
    transform: translate3d(0,0%,0);
  }
  10% {
    opacity: 1;
    transform: translate3d(0,0%,0);
  }
  70% {
    opacity: 1;
    transform: translate3d(0,556%,0);
  }
  80% {
    opacity: 0;
    transform: translate3d(0,556%,0);
  }
  100% {
    opacity: 0;
    transform: translate3d(0,556%,0);
  }
}
@keyframes leroy-excited {
  0% {
    transform: scale3d(0.26,0.26,1) translate3d(0%,0%,0);
  }
  13% {
    transform: scale3d(0.26,0.26,1) translate3d(30%,-10%,0);
  }
  26% {
    transform: scale3d(0.26,0.26,1) translate3d(60%,0%,0);
  }
  39% {
    transform: scale3d(0.26,0.26,1) translate3d(90%,-10%,0);
  }
  52% {
    transform: scale3d(0.26,0.26,1) translate3d(120%,0%,0);
  }
  65% {
    transform: scale3d(0.26,0.26,1) translate3d(90%,-10%,0);
  }
  78% {
    transform: scale3d(0.26,0.26,1) translate3d(60%,0%,0);
  }
  91% {
    transform: scale3d(0.26,0.26,1) translate3d(30%,-10%,0);
  }
  100% {
    transform: scale3d(0.26,0.26,1) translate3d(0%,0%,0);
  }
}
@keyframes leroy-running {
  0% {
    transform: scale3d(0.26,0.26,1) translate3d(0%,0%,0);
  }
  25% {
    transform: scale3d(0.23,0.23,1) translate3d(138%,-20%,0);
  }
  50% {
    transform: scale3d(0.19,0.19,1) translate3d(275%,-13%,0);
  }
  75% {
    transform: scale3d(0.15,0.15,1) translate3d(413%,-35%,0);
  }
  100% {
    transform: scale3d(0.12,0.12,1) translate3d(550%,-26%,0);
  }
}
@keyframes leroy-jumping {
  0% {
    transform: scale3d(0.4,0.4,1) translate3d(0%,0%,0);
  }
  5% {
    transform: scale3d(0.4,0.4,1) translate3d(0%,-10%,0);
  }
  10% {
    transform: scale3d(0.4,0.4,1) translate3d(0%,0%,0);
  }
  15% {
    transform: scale3d(0.4,0.4,1) translate3d(0%,-10%,0);
  }
  20% {
    transform: scale3d(0.4,0.4,1) translate3d(0%,0%,0);
  }
  25% {
    transform: scale3d(0.4,0.4,1) translate3d(0%,-10%,0);
  }
  30% {
    transform: scale3d(0.4,0.4,1) translate3d(0%,0%,0);
  }
  35% {
    transform: scale3d(0.4,0.4,1) translate3d(25%,-10%,0);
  }
  40% {
    transform: scale3d(0.4,0.4,1) translate3d(50%,0%,0);
  }
  45% {
    transform: scale3d(0.4,0.4,1) translate3d(25%,-10%,0);
  }
  50% {
    transform: scale3d(0.4,0.4,1) translate3d(0%,0%,0);
  }
  55% {
    transform: scale3d(0.4,0.4,1) translate3d(-25%,-10%,0);
  }
  60% {
    transform: scale3d(0.4,0.4,1) translate3d(-50%,0%,0);
  }
  65% {
    transform: scale3d(0.4,0.4,1) translate3d(-25%,-10%,0);
  }
  70% {
    transform: scale3d(0.4,0.4,1) translate3d(0%,0%,0);
  }
  75% {
    transform: scale3d(0.4,0.4,1) translate3d(25%,-10%,0);
  }
  80% {
    transform: scale3d(0.4,0.4,1) translate3d(50%,0%,0);
  }
  85% {
    transform: scale3d(0.4,0.4,1) translate3d(25%,-10%,0);
  }
  90% {
    transform: scale3d(0.4,0.4,1) translate3d(0%,0%,0);
  }
  95% {
    transform: scale3d(0.4,0.4,1) translate3d(0%,-10%,0);
  }
  100% {
    transform: scale3d(0.4,0.4,1) translate3d(0%,0%,0);
  }
}
.leroy {
  position: relative;
  width: fluid(136px);
  height: fluid(960px);
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: url('~@/assets/img/leroy-body.svg');
  transform-origin: 0% 0%;
  &__eyebrows {
    position: absolute;
    top: 16%;
    left: 0;
    width: 100%;
    height: fluid(24px);
    margin: 0 0 0 fluid(3px);
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    background-image: url('~@/assets/img/leroy-eyebrows.svg');
    animation: eyebrows 7s linear infinite;
  }
  &__mouth {
    position: absolute;
    top: 30.5%;
    left: 0;
    width: 100%;
    height: fluid(25px);
    margin: 0 0 0 fluid(6px);
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    background-image: url('~@/assets/img/leroy-mouth.svg');
  }
  &__tear {
    position: absolute;
    top: 29%;
    right: 25%;
    width: fluid(8px);
    height: fluid(18px);
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    background-image: url('~@/assets/img/water-drop.svg');
    animation: tear 4s linear infinite;
  }
  &__eyes {
    position: absolute;
    top: 21%;
    left: 0;
    width: 100%;
    margin: 0 0 0 fluid(4px);
  }
  &__eyes-open {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: fluid(89px);
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    background-image: url('~@/assets/img/leroy-eyes-open.svg');
  }
  &__eyes-half {
    display: none;
    position: absolute;
    top: fluid(25px);
    left: 0;
    width: 100%;
    height: fluid(65px);
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    background-image: url('~@/assets/img/leroy-eyes-half.svg');
  }
  &__eyes-closed {
    display: none;
    position: absolute;
    top: fluid(35px);
    left: 0;
    width: 100%;
    height: fluid(38px);
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    background-image: url('~@/assets/img/leroy-eyes-closed.svg');
  }
  &.eyes-half {
    .leroy {
      &__eyes-open {
        display: none;
      }
      &__eyes-half {
        display: block;
      }
    }
  }
  &.eyes-closed {
    .leroy {
      &__eyes-open {
        display: none;
      }
      &__eyes-closed {
        display: block;
      }
    }
  }
}
.leroy-excited {
  .leroy {
    animation: leroy-excited 1s linear;
  }
}
.leroy-running {
  .leroy {
    animation: leroy-running 0.75s linear forwards;
  }
}
.leroy-jumping {
  .leroy {
    animation: leroy-jumping 6s linear infinite;
  }
}
</style>